var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClosemenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.367,
    height: 24.62,
    viewBox: "0 0 28.367 24.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1196",
    "data-name": "Groupe 1196",
    transform: "translate(-1853.356 -46.379)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2782",
    "data-name": "Trac\\xE9 2782",
    d: "M1.447,11.289c10.33-.343,20.661.212,30.991,0,1.928-.04,1.935-3.04,0-3-10.33.212-20.661-.343-30.991,0-1.925.064-1.934,3.064,0,3",
    transform: "matrix(0.755, 0.656, -0.656, 0.755, 1861.512, 40.21)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2781",
    "data-name": "Trac\\xE9 2781",
    d: "M1.447.437C11.253.078,21.067.209,30.877,0c1.932-.042,1.931,2.958,0,3-9.81.209-19.624.078-29.43.437-1.931.071-1.928-2.929,0-3",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1881.529, 50.58)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosemenu);
export default __webpack_public_path__ + "static/media/closemenu.3e1330570f8b5aafea858842c498bbb2.svg";
export { ForwardRef as ReactComponent };